/*
  Dropdown custom pentru toate <select class="select__select"> din site.

  DE CE EXISTA: lista care se deschide dintr-un <select> nativ e desenata de
  sistemul de operare, nu de pagina. Niciun CSS nu o poate stiliza — de asta
  dropdownul de marimi de pe pagina de produs aparea ca o lista gri de Windows,
  complet in afara stilului temei. Singura solutie e sa desenam noi lista.

  Select-ul nativ RAMANE in DOM ca sursa de adevar: primeste `value` si un
  eveniment `change` care bubbles, deci submit-ul formularului, validarea
  nativa (`required`), `variant-selects`, sortarea de colectie si calculatorul
  de livrare raman neatinse. Daca JS-ul nu ruleaza, se vede select-ul nativ,
  cu sageata din component-select.css. Nu e nevoie sa editam niciun markup.

  Perechea de stil: assets/component-theme-select.css.
*/
(function () {
  'use strict';

  var SELECTOR = 'select.select__select';
  // Camp de cautare doar la liste chiar lungi (marimi de ghivece, tari).
  // Sub pragul asta lista se vede oricum aproape intreaga, iar campul ar fi
  // doar zgomot.
  var SEARCH_MIN = 15;

  // Aceeasi forma cu iconita `caret` din snippets/icon.liquid.
  var CARET =
    '<span class="tselect__caret" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 15" fill="none" focusable="false">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"/>' +
    '</svg></span>';

  var STR = { search: 'Căutare', empty: 'Nu s-au găsit rezultate' };
  if (window.themeSelectStrings) {
    if (window.themeSelectStrings.search) STR.search = window.themeSelectStrings.search;
    if (window.themeSelectStrings.empty) STR.empty = window.themeSelectStrings.empty;
  }

  // Normalizare pentru cautare: fara diacritice, ca „marime" sa gaseasca „Mărime".
  function norm(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[țţ]/g, 't')
      .replace(/[șş]/g, 's')
      .trim();
  }

  var instances = [];

  function closeAll(except) {
    instances.forEach(function (i) {
      if (i !== except) i.close();
    });
  }

  function TSelect(select) {
    this.select = select;
    this.options = [];
    this.active = -1;
    this.build();
  }

  TSelect.prototype.build = function () {
    var s = this.select;
    s.dataset.tselect = '1';

    var wrap = document.createElement('div');
    wrap.className = 'tselect';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    // Trigger-ul preia clasele select-ului nativ, deci mosteneste tot stilul
    // deja definit pe `.select__select` (inaltime, chenar, padding, font) plus
    // orice adaugare de context (ex. fundalul gri din formularul de contact).
    trigger.className = s.className + ' tselect__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = '<span class="tselect__value"></span>' + CARET;
    if (s.disabled) trigger.disabled = true;

    var panel = document.createElement('div');
    panel.className = 'tselect__panel';
    panel.hidden = true;

    var search = document.createElement('input');
    search.type = 'text';
    search.className = 'tselect__search';
    search.setAttribute('role', 'combobox');
    search.setAttribute('aria-autocomplete', 'list');
    search.setAttribute('aria-expanded', 'true');
    search.autocomplete = 'off';
    search.placeholder = STR.search;

    var list = document.createElement('ul');
    list.className = 'tselect__list';
    list.setAttribute('role', 'listbox');
    if (s.id) list.id = s.id + '-tselect-list';

    var empty = document.createElement('li');
    empty.className = 'tselect__empty';
    empty.textContent = STR.empty;
    empty.hidden = true;

    panel.appendChild(search);
    panel.appendChild(list);
    list.appendChild(empty);
    wrap.appendChild(trigger);
    wrap.appendChild(panel);

    s.parentNode.insertBefore(wrap, s);
    s.classList.add('tselect-native');
    // Nativul iese din tab-order, altfel Tab s-ar opri de doua ori pe acelasi
    // camp. focus() programatic (validarea nativa) continua sa functioneze.
    s.setAttribute('tabindex', '-1');
    s.setAttribute('aria-hidden', 'true');

    // Numele accesibil al trigger-ului = eticheta campului.
    if (s.id) {
      var lbl = document.querySelector('label[for="' + s.id + '"]');
      if (lbl) {
        if (!lbl.id) lbl.id = s.id + '-tselect-label';
        trigger.setAttribute('aria-labelledby', lbl.id);
      }
    } else if (s.getAttribute('aria-label')) {
      trigger.setAttribute('aria-label', s.getAttribute('aria-label'));
    }

    this.wrap = wrap;
    this.trigger = trigger;
    this.valueEl = trigger.querySelector('.tselect__value');
    this.panel = panel;
    this.search = search;
    this.list = list;
    this.empty = empty;

    this.render();
    this.syncValue();
    this.bind();
  };

  TSelect.prototype.render = function () {
    var self = this;
    Array.prototype.slice
      .call(this.list.querySelectorAll('.tselect__option'))
      .forEach(function (n) {
        n.remove();
      });
    this.options = [];

    Array.prototype.forEach.call(this.select.options, function (opt) {
      var li = document.createElement('li');
      li.className = 'tselect__option';
      li.setAttribute('role', 'option');
      li.dataset.value = opt.value;
      li.textContent = opt.textContent.trim();
      if (opt.disabled) li.setAttribute('aria-disabled', 'true');
      // Optiunile de varianta indisponibile sunt marcate din Liquid.
      if (opt.dataset.crossout !== undefined) li.classList.add('tselect__option--unavailable');
      // Optiunea cu valoare goala e un placeholder („Alege..."), nu o alegere:
      // ramane in lista ca sa se poata reveni la ea, dar fara bifa de selectat.
      if (opt.value === '') li.classList.add('tselect__option--placeholder');
      li.setAttribute('aria-selected', self.isChosen(opt.value) ? 'true' : 'false');
      // `mousedown` in loc de `click`, ca sa nu pierdem focusul inainte de
      // alegere. `click` ramane ca plasa de siguranta pe touch, unde nu toate
      // browserele emit mousedown pe elemente fara rol de buton; `choose` cu
      // aceeasi valoare nu mai emite `change`, deci nu se executa de doua ori.
      var pick = function (e) {
        e.preventDefault();
        if (opt.disabled) return;
        self.choose(opt.value);
      };
      li.addEventListener('mousedown', pick);
      li.addEventListener('click', pick);
      self.list.insertBefore(li, self.empty);
      self.options.push(li);
    });

    this.search.style.display = this.options.length >= SEARCH_MIN ? '' : 'none';
  };

  TSelect.prototype.isChosen = function (value) {
    return value !== '' && value === this.select.value;
  };

  TSelect.prototype.syncValue = function () {
    var s = this.select;
    var self = this;
    var sel = s.options[s.selectedIndex];
    this.valueEl.textContent = sel ? sel.textContent.trim() : '';
    this.wrap.classList.toggle('tselect--empty', !sel || sel.value === '');
    this.options.forEach(function (li) {
      li.setAttribute('aria-selected', self.isChosen(li.dataset.value) ? 'true' : 'false');
    });
    this.trigger.classList.toggle('invalid', s.classList.contains('invalid'));
    this.trigger.disabled = s.disabled;
  };

  TSelect.prototype.choose = function (value) {
    if (this.select.value !== value) {
      this.select.value = value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.syncValue();
    this.close();
    this.trigger.focus();
  };

  TSelect.prototype.filter = function (q) {
    var nq = norm(q);
    var visible = 0;
    this.options.forEach(function (li) {
      var show = !nq || norm(li.textContent).indexOf(nq) > -1;
      li.hidden = !show;
      if (show) visible++;
    });
    this.empty.hidden = visible > 0;
    this.setActive(this.firstVisible());
  };

  TSelect.prototype.firstVisible = function () {
    for (var i = 0; i < this.options.length; i++) {
      if (!this.options[i].hidden) return i;
    }
    return -1;
  };

  TSelect.prototype.setActive = function (idx) {
    if (this.active > -1 && this.options[this.active]) {
      this.options[this.active].classList.remove('is-active');
    }
    this.active = idx;
    if (idx > -1 && this.options[idx]) {
      var li = this.options[idx];
      li.classList.add('is-active');
      if (!li.id) li.id = (this.list.id || 'tselect') + '-opt-' + idx;
      this.search.setAttribute('aria-activedescendant', li.id);
      this.scrollIntoList(li);
    } else {
      this.search.removeAttribute('aria-activedescendant');
    }
  };

  /*
    Aduce optiunea activa in vizor mutand DOAR scroll-ul listei.
    `li.scrollIntoView()` ar fi mai scurt, dar scroleaza si pagina din spate:
    la deschidere muta trigger-ul sub masuratoarea din `place()`, care apoi
    decidea gresit ca lista nu incape in jos si o deschidea in sus.
  */
  TSelect.prototype.scrollIntoList = function (li) {
    var list = this.list;
    var top = li.offsetTop;
    var bottom = top + li.offsetHeight;
    if (top < list.scrollTop) list.scrollTop = top;
    else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
  };

  TSelect.prototype.moveActive = function (dir) {
    var n = this.options.length;
    if (!n) return;
    var i = this.active;
    for (var guard = 0; guard < n; guard++) {
      i += dir;
      if (i < 0) i = n - 1;
      if (i >= n) i = 0;
      if (!this.options[i].hidden) {
        this.setActive(i);
        return;
      }
    }
  };

  /*
    Exista vreun parinte care taie ce iese din el?

    Panoul e pozitionat absolut fata de wrapper, deci orice parinte cu
    `overflow` diferit de `visible` il retează. Cazul real: bara sticky de
    „adauga in cos" de pe pagina de produs — `variant-selects` de acolo are
    `overflow: auto hidden`, asa ca lista se deschidea corect dar nu se vedea
    absolut deloc. La fel ar pati orice dropdown dintr-un drawer sau modal.
  */
  TSelect.prototype.isClipped = function () {
    var e = this.wrap.parentElement;
    while (e && e !== document.body) {
      var cs = getComputedStyle(e);
      if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') return true;
      e = e.parentElement;
    }
    return false;
  };

  /*
    Aseaza panoul: in sus daca nu incape in jos si, cand exista un parinte care
    taie, scos in `<body>` cu pozitie fixa (asa scapa de orice `overflow`).
  */
  TSelect.prototype.place = function () {
    var r = this.trigger.getBoundingClientRect();
    var below = window.innerHeight - r.bottom;
    var needed = Math.min(this.panel.scrollHeight || 280, 280) + 12;
    var up = below < needed && r.top > below;
    this.wrap.classList.toggle('tselect--up', up);

    if (!this.floating) return;

    /*
      Latimea: cel putin 240px, ca etichetele lungi („13.2 x 11.8 / Maro cald")
      sa nu se rupa pe doua randuri — trigger-ul din bara sticky are doar 174px.
      Apoi impingem panoul inapoi in ecran daca ar iesi pe dreapta.
    */
    var w = Math.max(r.width, Math.min(240, window.innerWidth - 16));
    var left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8));

    var s = this.panel.style;
    s.left = left + 'px';
    s.right = 'auto'; // altfel `inset-inline: 0` din CSS ar mai tine dreapta
    s.width = w + 'px';

    /*
      Pe verticala ancoram mereu prin `top`, niciodata prin `bottom`: bara
      sticky isi asaza pozitia dupa deschidere, iar o ancorare de jos calculata
      pe pozitia veche scotea panoul afara din ecran.

      Inaltimea se limiteaza la spatiul disponibil, apoi `top` se strange in
      ecran — asa panoul ramane vizibil intreg indiferent de unde e campul.
    */
    var margin = 14;
    var space = up ? r.top - margin : window.innerHeight - r.bottom - margin;
    s.maxHeight = Math.max(120, Math.min(280, space)) + 'px';
    var h = this.panel.offsetHeight;
    var top = up ? r.top - 6 - h : r.bottom + 6;

    s.top = Math.max(8, Math.min(top, window.innerHeight - h - 8)) + 'px';
    s.bottom = 'auto';
  };

  TSelect.prototype.open = function () {
    if (!this.panel.hidden) return;
    closeAll(this);

    // Scoatem panoul in <body> doar cand chiar e nevoie: acolo pierde
    // mostenirea de culori a sectiunii, deci nu o facem preventiv.
    this.floating = this.isClipped();
    if (this.floating) {
      // In <body> panoul pierde schema de culori a sectiunii (`.color-...`),
      // deci ii copiem variabilele calculate, ca sa arate identic.
      var cs = getComputedStyle(this.wrap);
      ['--color-foreground', '--color-background', '--color-border', '--color-shadow', '--button-radius'].forEach(
        function (v) {
          this.panel.style.setProperty(v, cs.getPropertyValue(v));
        },
        this
      );
      this.panel.classList.add('tselect__panel--fixed');
      // Intr-un <dialog> deschis cu showModal(), `body` e sub backdrop: panoul
      // mutat acolo ramane invizibil. Dialogul e in top layer, deci e singura
      // gazda din care panoul se mai vede.
      var host = this.wrap.closest('dialog');
      if (!host || !host.open) host = document.body;
      host.appendChild(this.panel);
    }

    this.panel.hidden = false;
    this.wrap.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.search.value = '';
    this.filter('');

    var self = this;
    var cur = -1;
    this.options.forEach(function (li, i) {
      if (li.dataset.value === self.select.value) cur = i;
    });
    if (cur > -1) this.setActive(cur);

    this.place();
    if (this.search.style.display !== 'none') this.search.focus();

    // Bara sticky de pe pagina de produs isi termina animatia dupa deschidere,
    // deci reasezam odata dupa ce s-a linistit layoutul.
    var self2 = this;
    requestAnimationFrame(function () {
      if (!self2.panel.hidden) self2.place();
    });
  };

  TSelect.prototype.close = function () {
    if (this.panel.hidden) return;
    this.panel.hidden = true;
    this.wrap.classList.remove('is-open', 'tselect--up');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.setActive(-1);

    if (this.floating) {
      this.floating = false;
      this.panel.classList.remove('tselect__panel--fixed');
      this.panel.removeAttribute('style');
      this.wrap.appendChild(this.panel);
    }
  };

  TSelect.prototype.bind = function () {
    var self = this;

    this.trigger.addEventListener('click', function () {
      if (self.panel.hidden) self.open();
      else self.close();
    });

    this.trigger.addEventListener('keydown', function (e) {
      if (self.panel.hidden) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          self.open();
        }
        return;
      }
      // Panou deschis fara camp de cautare: focusul ramane pe trigger, deci
      // navigarea din tastatura se trateaza aici.
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          self.moveActive(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          self.moveActive(-1);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (self.active > -1 && self.options[self.active]) {
            self.choose(self.options[self.active].dataset.value);
          }
          break;
        case 'Escape':
          e.preventDefault();
          self.close();
          break;
        case 'Tab':
          self.close();
          break;
      }
    });

    this.search.addEventListener('input', function () {
      self.filter(this.value);
    });

    this.search.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          self.moveActive(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          self.moveActive(-1);
          break;
        case 'Enter':
          e.preventDefault();
          if (self.active > -1 && self.options[self.active]) {
            self.choose(self.options[self.active].dataset.value);
          }
          break;
        case 'Escape':
          e.preventDefault();
          self.close();
          self.trigger.focus();
          break;
        case 'Tab':
          self.close();
          break;
      }
    });

    // Panoul poate fi mutat in <body>, deci nu mai e in `wrap`: se verifica
    // separat, altfel clicul pe o optiune ar inchide lista inainte de alegere.
    document.addEventListener('mousedown', function (e) {
      if (!self.wrap.contains(e.target) && !self.panel.contains(e.target)) self.close();
    });

    // Panoul fix nu se misca odata cu pagina, deci il reasezam cat e deschis.
    var reposition = function () {
      if (self.floating && !self.panel.hidden) self.place();
    };
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);

    // Nativul e sursa de adevar: orice schimbare venita din alta parte
    // (ex. `variant-selects` care selecteaza automat o varianta) se reflecta.
    this.select.addEventListener('change', function () {
      self.syncValue();
    });

    // Liste repopulate dinamic (judete dupa tara, optiuni dupa varianta).
    if (typeof MutationObserver === 'function') {
      this.observer = new MutationObserver(function (muts) {
        var rebuild = false;
        muts.forEach(function (m) {
          if (m.type === 'childList') rebuild = true;
          if (m.type === 'attributes') {
            self.trigger.className = self.select.className.replace('tselect-native', '') + ' tselect__trigger';
            self.trigger.disabled = self.select.disabled;
          }
        });
        if (rebuild) {
          self.render();
          self.syncValue();
        }
      });
      this.observer.observe(this.select, {
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'disabled'],
      });
    }
  };

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selects = scope.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(selects, function (s) {
      if (s.dataset.tselect === '1') return;
      instances.push(new TSelect(s));
    });
  }

  /*
    Sectiunile se re-randeaza din JS in mai multe locuri (pickerul de variante
    dupa schimbarea variantei, filtrele de colectie, mini-cosul, Theme Editor).
    Fara observatorul global, dropdownurile aparute dupa incarcare ar ramane
    native. rAF grupeaza rafalele de mutatii intr-o singura trecere.
  */
  var pending = false;
  function scheduleInit() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      // Sectiunile re-randate lasa in urma instante cu DOM detasat; le scoatem
      // ca lista sa nu creasca la nesfarsit intr-o sesiune lunga.
      instances = instances.filter(function (i) {
        return i.wrap.isConnected;
      });
      init(document);
    });
  }

  function start() {
    init(document);
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) {
            scheduleInit();
            return;
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
